// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"m3","cardInnerHeading":"m4","toggleWrapperClass":"m5","changeProfile":"m6 m5","textWrapperClass":"m7","toggleTextClass":"m8","warningMessage":"m9"};